<template>
  <div>
    <!-- Splash Screen (with integrated password if not authenticated) -->
    <TravelSplashScreen
      v-if="showSplash"
      @splash-complete="handleSplashComplete"
      @authenticated="handleAuthenticated"
    />

    <!-- Main Content (preloaded but hidden until splash completes) -->
    <div v-show="isAuthenticated && !showSplash" class="travel-content">
      <!-- <div class="hidden md:block">
        <Banner />
      </div> -->
      <Navbar />
      <!-- <div class="md:hidden">
        <Banner />
      </div> -->
      <IntroSection />
      <section id="HowItWorks">
        <HowItWorksSection />
      </section>
      <section id="Features" class="overflow-hidden">
        <FeatureSection />
      </section>
      <section id="PublicItineraries" class="overflow-hidden">
        <PopularItineraries />
      </section>
      <Quiz />
      <!-- <section id="TravelAgent" class="section-color-2">
        <TravelAgent />
      </section> 
      <section id="GiftTravel">
        <GiftTravel />
      </section> -->
      <section id="Testimonials">
        <Testimonials />
      </section>
      <FeaturedIn class="section-color-3" />
      <section id="FAQ">
        <FAQ />
      </section>
      <CTA />
      <Footer />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { onMounted, ref } from 'vue';
import * as amplitude from '@amplitude/analytics-browser';
// import Banner from '@/components/Banner.vue';
import Navbar from '@/components/Navbar.vue';
import TravelSplashScreen from '@/components/TravelSplashScreen.vue';
import Quiz from '@/components/Quiz.vue';
import PopularItineraries from '@/components/PopularItineraries.vue';
// import TravelAgent from '@/components/TravelAgent.vue';
import Testimonials from '@/components/Testimonials.vue';
import FeaturedIn from '@/components/FeaturedIn.vue';
import FAQ from '@/components/FAQ.vue';
import CTA from '@/components/CTA.vue';
import Footer from '@/components/Footer.vue';
import FeatureSection from '@/components/FeatureSection.vue';
import HowItWorksSection from '@/components/HowItWorksSection.vue';
import IntroSection from '../components/IntroSection.vue';

export default {
  name: 'TravelPage',
  components: {
    // Banner,
    Navbar,
    TravelSplashScreen,
    FeatureSection,
    Quiz,
    PopularItineraries,
    // TravelAgent,
    Testimonials,
    FeaturedIn,
    FAQ,
    CTA,
    Footer,
    HowItWorksSection,
    IntroSection,
  },
  setup() {
    const showSplash = ref(true);
    const isAuthenticated = ref(false);

    // Check if already authenticated
    const isAlreadyAuthenticated =
      sessionStorage.getItem('travel_authenticated') === 'true';
    if (isAlreadyAuthenticated) {
      isAuthenticated.value = true;
      // Keep splash screen showing - it will show navbar and animation
    }

    const handleSplashComplete = () => {
      showSplash.value = false;
      // If we reach here, user is authenticated (password was handled in splash)
      isAuthenticated.value = true;
    };

    const handleAuthenticated = () => {
      // Password was entered correctly, authentication stored
      // Splash will complete shortly after
      isAuthenticated.value = true;
    };

    onMounted(() => {
      // Preload content in background regardless of authentication
      // This ensures content is ready when password is entered
      const apiKey =
        process.env.VUE_APP_ENDPOINTS === 'production'
          ? 'a8a56f173be65492fcf99607fa54c5cc'
          : 'eec0ac28984d63289b4a88e42518d23f';

      // Initialize Amplitude
      amplitude.init(apiKey, {
        defaultTracking: true,
        transport: 'beacon',
        flushIntervalMillis: 0,
        flushQueueSize: 1,
      });
    });

    return {
      showSplash,
      isAuthenticated,
      handleSplashComplete,
      handleAuthenticated,
    };
  },
};
</script>

<style scoped>
.travel-content {
  opacity: 0;
  animation: content-fade-in 0.8s ease-out 0.2s both;
}

@keyframes content-fade-in {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.section-color-2 {
  background: #eff7fc;
}

.section-color-3 {
  background: linear-gradient(to top, #e8f4fb 0%, #ffffff 100%);
}
</style>
